import { GET_PROFILE } from '../constants/profile';

// eslint-disable-next-line import/prefer-default-export
export const getProfile = (data) => {
  // eslint-disable-next-line camelcase
  const { email, username, slug, name, surname, bio, phone, image, is_owner } = data ?? {};

  return (dispatch) => {
    dispatch({
      type: GET_PROFILE,
      email,
      username,
      slug,
      name,
      surname,
      bio,
      phone,
      image,
      isOwner: is_owner,
    });
  };
};
